// Single source of truth for "is this the sandbox demo tenant".
export const DEMO_TENANT_ID = "elementar_demo";

export const isDemoUser = (user) => user?.tenant_id === DEMO_TENANT_ID;

/**
 * "Create your account" from inside the demo: drop the sandbox session, then
 * go to the public register page. The /demo ?s= campaign tag is not stored and
 * RegisterPage does not read one, so this is plain /register.
 */
export async function leaveDemoForRegister(logout, navigate) {
  try {
    await logout();
  } finally {
    // Hard navigation: logout() clears user, and the protected-route redirect to /login would race a router navigate.
    window.location.assign("/register");
  }
}
